import { render, staticRenderFns } from "./TaskProjectTransferModal.vue?vue&type=template&id=a5478a58&scoped=true"
import script from "./TaskProjectTransferModal.vue?vue&type=script&lang=js"
export * from "./TaskProjectTransferModal.vue?vue&type=script&lang=js"
import style0 from "./TaskProjectTransferModal.vue?vue&type=style&index=0&id=a5478a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5478a58",
  null
  
)

export default component.exports